// extracted by mini-css-extract-plugin
module.exports = {"table":"styles-module_table_3RmdV","edit":"styles-module_edit_1syXE","buttons":"styles-module_buttons_41cdu"};